import React from "react";

const GrowthSection = ({ openModal }) => {
  return (
    <>
      <style>{`
        .growth-section {
          background: linear-gradient(180deg, #F6F6F6 0%, #ffffff 100%);
          padding: 32px 0px;
        }

        /* ── Header ── */
        .growth-heading {
          font-size: clamp(26px, 4vw, 42px);
          font-weight: 800;
          color: #1a1a1a;
          text-align: center;
          margin-bottom: 0;
          line-height: 1.2;
        }
        .growth-heading span {
          background: linear-gradient(90deg, #B40103, #4E0001);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .growth-sub {
          background: linear-gradient(90deg, #B40103, #4E0001);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-weight: 600;
          font-size: 15px;
          text-align: center;
          padding: 8px 0 4px;
          margin-bottom: 0;
          display: block;
        }
        .growth-desc {
          font-size: 14px;
          color: #515151;
          text-align: center;
          line-height: 1.75;
          margin-bottom: 0;
        }

        /* ── Big Left Card ── */
        .big-card {
          background: #ffffff;
          border-radius: 20px;
          box-shadow: 0 4px 28px rgba(0,0,0,0.09);
          padding: 0px 0px 32px 32px;
          height: 100%;
          display: flex;
          align-items: center;
          overflow: hidden;
        }
        .big-card-inner {
          display: flex;
          align-items: center;
          width: 100%;
        }
        .big-card-text {
          flex: 0 0 55%;
          padding-right: 16px;
          z-index: 2;
        }
        .big-number {
          font-size: clamp(68px, 8vw, 96px);
          font-weight: 900;
          color: #e00000;
          line-height: 1;
          letter-spacing: -3px;
          margin-bottom: 10px;
          display: block;
          position: relative;
        }
          .big-number span {
            position: absolute;
            top: -36%;
            right: -28%;
            z-index: 9999;
        //    color: "#E31E24",
           textShadow: "-3px 0 #fff"
          }
        .big-card-title {
          font-size: 19px;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 8px;
          line-height: 1.3;
        }
        .big-card-desc {
          font-size: 13.5px;
          color: #6c757d;
          line-height: 1.65;
          margin: 0;
        }

        /* ── Circle Cluster ── */
        .circles-wrap {
          flex: 0 0 45%;
          position: relative;
          height: 250px;
          overflow: visible;
        }
        .ci {
          position: absolute;
          border-radius: 50%;
          border: 3.5px solid #ffffff;
          box-shadow: 0 4px 16px rgba(0,0,0,0.13);
          overflow: hidden;
          background: #c8c8c8;
        }
        .ci img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
        /* Screenshot-exact positions:
           - c-top-right: top right area, medium
           - c-top-left: top left, partially cut, small
           - c-mid-left: middle left, medium
           - c-center: biggest, center-right, main student
           - c-bot-left: bottom left, small
        */
        .c-top-right  { width: 80px;  height: 80px;  top: 10%;   left: 43%; }
        .c-top-left   { width: 80px;  height: 80px;  top: 3%;   left: 72%;  }
        .c-mid-left   { width: 80px;  height: 80px;  top: 41%;  left: 26%;  }
        .c-center     { width: 182px; height: 182px; top: 39%;  left: 53%; }
        .c-bot-left   { width: 80px;  height: 80px;  top: 80%; left: 27%;  }

        /* ── Right Cards ── */
        .right-cards {
          display: flex;
          flex-direction: column;
          gap: 18px;
          height: 100%;
        }
        .small-card {
          background: #ffffff;
          border-radius: 20px;
          box-shadow: 0 4px 28px rgba(0,0,0,0.09);
          padding: 8px 0px 8px 18px;
          display: flex;
          align-items: center;
          gap: 14px;
          flex: 1;
        }
        .sc-icon {
          width: 44px;
          height: 44px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .sc-icon svg {
          width: 36px;
          height: 36px;
        }
        .sc-text { flex: 1; min-width: 0; }
        .sc-title {
          font-size: 15px;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 5px;
          line-height: 1.3;
        }
        .sc-desc {
          font-size: 12.5px;
          color: #6c757d;
          margin: 0;
          line-height: 1.55;
        }
        .sc-desc span { color: #e00000; font-weight: 600; }
        .sc-photo {
        //   width: 90px;
        //   height: 76px;
          border-radius: 12px;
          overflow: hidden;
          flex-shrink: 0;
          background: #e0e0e0;
        }
      .sc-photo {
    height: 119px;
    width: 178px;
    border-radius: 50px 0px 0px 50px;
    overflow: hidden;
    flex-shrink: 0;
    background: #e0e0e0;
}

        /* ── Apply Button ── */
        .apply-btn {
          background: linear-gradient(90deg, #e00000, #b40103);
          color: #fff;
          border: none;
          border-radius: 30px;
          padding: 13px 40px;
          font-weight: 600;
          font-size: 15px;
          cursor: pointer;
          letter-spacing: 0.2px;
          box-shadow: 0 4px 18px rgba(224,0,0,0.35);
          transition: transform 0.18s ease, box-shadow 0.18s ease;
          display: inline-flex;
          align-items: center;
          gap: 6px;
        }
        .apply-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(224,0,0,0.45);
        }

        /* ── Tablet ── */
        @media (max-width: 991px) {
          .big-number { font-size: 80px; }
          .c-center  { width: 110px; height: 110px; top: 62px; left: 34%; }
          .circles-wrap { height: 230px; display: none; }
          .big-card-text {
           flex: 0 0 100%;
         }
           .sc-photo{
           display: none;}
        }

        /* ── Mobile ── */
        @media (max-width: 767px) {
          .growth-section { padding: 36px 0 48px; }
          .big-card { padding: 24px 20px; }
          .big-card-inner { flex-direction: column; gap: 28px; }
          .big-card-text { flex: unset; width: 100%; padding-right: 0; }
          .big-number { font-size: 78px; }

          .circles-wrap {
          display: none;
            flex: unset;
            width: 100%;
            height: 210px;
          }
          .c-top-right { width: 78px;  height: 78px;  top: 0px;   left: 44%; }
          .c-top-left  { width: 62px;  height: 62px;  top: 6px;   left: 4%;  }
          .c-mid-left  { width: 74px;  height: 74px;  top: 68px;  left: 2%;  }
          .c-center    { width: 110px; height: 110px; top: 48px;  left: 30%; }
          .c-bot-left  { width: 70px;  height: 70px;  top: 134px; left: 5%;  }

          .small-card { padding: 16px 14px; gap: 10px; }
          .sc-photo { width: 78px; height: 66px; display: none;}
        }

        /* ── Small Mobile ── */
        @media (max-width: 480px) {
          .big-number { font-size: 64px; }
          .big-card-title { font-size: 16px; }
          .sc-photo { display: none; }
          .circles-wrap { height: 190px; }
          .c-top-right { width: 70px;  height: 70px; }
          .c-center    { width: 96px;  height: 96px; top: 50px; left: 28%; }
        }
      `}</style>

      <div className="growth-section">
        <div className="container">

          {/* Heading */}
          <h2 className="growth-heading">
            Your Growth, <span>Our Mission</span>
          </h2>
          <span className="growth-sub">Shaping Bright Minds for a Competitive World</span>

          {/* Description */}
          <div className="row justify-content-center mb-4 mt-2">
            <div className="col-lg-6 col-md-8 col-11">
              <p className="growth-desc">
                Regarded as one of the best BTech colleges in Rajasthan, Arya College delivers
                advanced technical education combined with practical, real-world learning to shape
                industry-ready engineers.
              </p>
            </div>
          </div>

          {/* Cards Row */}
          <div className="row g-4 align-items-stretch">

            {/* ── Left Big Card ── */}
            <div className="col-md-7">
              <div className="big-card">
                <div className="big-card-inner">

                  {/* Text */}
                  <div className="big-card-text d-flex">
                    <div className="big-number">26 <span>+</span></div>
                    <div className="ps-lg-5 ps-4">
                      <div className="big-card-title">Highest RTU Merits</div>
                      <p className="big-card-desc">
                        Arya College produced 26 of RTU's top 60 students.
                      </p>
                    </div>

                  </div>

                  {/* Circle Cluster */}
                  <div className="circles-wrap">
                    {/* top-right */}
                    <div className="ci c-top-right">
                      <img src="/images/circle4.webp" alt="student"
                        onError={e => { e.target.style.display = "none"; }} />
                    </div>
                    {/* top-left (partial) */}
                    <div className="ci c-top-left">
                      <img src="/images/circle3.webp" alt="student"
                        onError={e => { e.target.style.display = "none"; }} />
                    </div>
                    {/* mid-left */}
                    <div className="ci c-mid-left">
                      <img src="/images/circle2.webp" alt="student"
                        onError={e => { e.target.style.display = "none"; }} />
                    </div>
                    {/* center big — main student */}
                    <div className="ci c-center">
                      <img src="/images/circle_main.webp" alt="student"
                        onError={e => { e.target.style.display = "none"; }} />
                    </div>
                    {/* bottom-left */}
                    <div className="ci c-bot-left">
                      <img src="/images/circle1.webp" alt="student"
                        onError={e => { e.target.style.display = "none"; }} />
                    </div>
                  </div>

                </div>
              </div>
            </div>

            {/* ── Right Small Cards ── */}
            <div className="col-md-5">
              <div className="right-cards">

                {/* Card 1 – Successful Alumni */}
                <div className="small-card">
                  <div className="sc-icon">
                    {/* Graduation cap SVG — matches screenshot */}
                    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M24 6L4 16L24 26L44 16L24 6Z" stroke="#e00000" strokeWidth="2.5" strokeLinejoin="round" fill="none" />
                      <path d="M12 21V33C12 33 16 38 24 38C32 38 36 33 36 33V21" stroke="#e00000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                      <line x1="44" y1="16" x2="44" y2="30" stroke="#e00000" strokeWidth="2.5" strokeLinecap="round" />
                      <circle cx="44" cy="32" r="2.5" fill="#e00000" />
                    </svg>
                  </div>
                  <div className="sc-text">
                    <div className="sc-title">Successful Alumni.</div>
                    <p className="sc-desc">
                      Arya College has <span>15,000+</span> alumni placed in top global MNCs.
                    </p>
                  </div>
                  <div className="sc-photo">
                    <img className="w-100 h-100" src="/images/rounded1.webp" alt="alumni"
                      onError={e => { e.target.style.display = "none"; }} />
                  </div>
                </div>

                {/* Card 2 – Best RTU */}
                <div className="small-card">
                  <div className="sc-icon">
                    {/* Trophy SVG — matches screenshot */}
                    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14 6H34V26C34 32.627 29.523 38 24 38C18.477 38 14 32.627 14 26V6Z" stroke="#e00000" strokeWidth="2.5" strokeLinejoin="round" fill="none" />
                      <path d="M14 10H8C8 10 6 20 14 22" stroke="#e00000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                      <path d="M34 10H40C40 10 42 20 34 22" stroke="#e00000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                      <line x1="24" y1="38" x2="24" y2="44" stroke="#e00000" strokeWidth="2.5" strokeLinecap="round" />
                      <line x1="16" y1="44" x2="32" y2="44" stroke="#e00000" strokeWidth="2.5" strokeLinecap="round" />
                    </svg>
                  </div>
                  <div className="sc-text">
                    <div className="sc-title">Best RTU Affiliated College</div>
                    <p className="sc-desc">
                      Arya College ranks <span>Top 5</span> in RTU, powered by 4 Centers of Excellence.
                    </p>
                  </div>
                  <div className="sc-photo">
                    <img className="w-100 h-100" src="/images/rounded2.webp" alt="college"
                      onError={e => { e.target.style.display = "none"; }} />
                  </div>
                </div>

              </div>
            </div>

          </div>{/* /row */}

          {/* Apply Button */}
          <div className="text-center mt-5">
            <button
              className="apply-btn"
              onClick={() => openModal && openModal("Apply Now")}
            >
              Apply Now →
            </button>
          </div>

        </div>
      </div>
    </>
  );
};

export default GrowthSection;